<template>
  <div class="fBanner" :style="{ marginTop }">
    <div class="title">合作客户</div>
    <div class="clients_content">
      <div class="clients_wrap">
        <img src="https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/home/logo.png" alt="" class="kehu_left">
        <img src="https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/home/logo.png" alt="" class="kehu_right">
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        notMarginTop: ['private', 'purchase', 'marketing'],
        marginTop: 0
      };
    },
    created() {
      this.marginTop = this.notMarginTop.includes(this.$route.name) ? '0' : '96px'
    }
  }
</script>
<style lang="scss" scoped>
.fBanner {
  width: 1240px;
  margin: 0 auto 80px;
  .title {
    min-width: 1240px;
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3B3946;
    line-height: 45px;
    margin-bottom: 8px;
    text-align: center;
  }
  .clients_content {
    margin: 0 auto;
    .clients_wrap {
      height: 284px;
      position: relative;
      overflow: hidden;
      &::before {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        z-index: 9;
        background-image: url('https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/solution/solution_logo_mark.png');
        background-size: 1240px 384px;
        background-repeat: no-repeat;
      }
      img {
        height: 284px;
        object-fit: contain;
        position: absolute;
        top: 50%;
        left: 0;
      }
      .kehu_left {
        transform: translate(0, -50%);
        animation: swiper-left 60s linear infinite;
      }
      .kehu_right {
        transform: translate(calc(100% - 1px), -50%);
        animation: swiper-right 60s linear infinite;
      }
      @keyframes swiper-left {
        0% {
          transform: translate(0, -50%);
        }
        to {
          transform: translate(-100%, -50%);
        }
      }
      @keyframes swiper-right {
        0% {
          transform: translate(calc(100% - 1px), -50%);
        }
        to {
          transform: translate(-1px, -50%);
        }
      }
    }
  }
}
</style>
